import { CommonModule } from "@angular/common";
import {
  ModuleWithProviders,
  NgModule,
  Optional,
  SkipSelf,
} from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { TranslateModule } from "@ngx-translate/core";
import { IonicModule, IonicPageModule } from "ionic-angular";
import { CommonComponentsModule } from "../components/common/common-components.module";
import { CertificationReceivedModuleV2 } from "./forms/certification-received-v2/certification-received-v2.module";
import { CertificationReceivedModule } from "./forms/certification-received/certification-received.module";
import { InitialCtiForm } from "./forms/initial.cti/initial.cti";
import { ReferralCertificationModule } from "./forms/referral-certification/referral-certification.module";
import { CtiConfirmPage } from "./pages/cti-confirmation/cti-confirm.page";
import { CertificationService } from "./services/certification-service";

@NgModule({
  imports: [
    CommonModule,
    TranslateModule.forChild(),
    IonicPageModule.forChild(CtiConfirmPage),
    IonicModule,
    FontAwesomeModule,
    ReactiveFormsModule,
    CommonComponentsModule,
    CertificationReceivedModule,
    ReferralCertificationModule,
    CertificationReceivedModuleV2,
  ],
  declarations: [InitialCtiForm, CtiConfirmPage, InitialCtiForm],
  exports: [InitialCtiForm, CtiConfirmPage, InitialCtiForm],
  entryComponents: [InitialCtiForm, CtiConfirmPage],
})
export class CertificationModule {
  constructor(@Optional() @SkipSelf() parentModule: CertificationModule) {
    if (parentModule) {
      console.warn(
        "CertificationModule is already loaded. Import it in the AppModule only."
      );
    }
  }

  static forRoot(certificationServiceUrl: string): ModuleWithProviders {
    return {
      ngModule: CertificationModule,
      providers: [
        {
          provide: "CertificationServiceUrl",
          useValue: certificationServiceUrl,
        },
        CertificationService,
      ],
    };
  }
}



// WEBPACK FOOTER //
// ./src/certification/certification.module.ts